const domain: string = 'FOOTER'

export const SAVE_FOOTER: string = `${domain}/SAVE_FOOTER`
